import React from 'react';
import CommunicationPreferencesIndex from "../../communication_preferences";
export function communicationPreferencesRoutes() { return [{ path: '/my_rift/communication_preferences', element: /*#__PURE__*/ React.createElement(CommunicationPreferencesIndex, null) }]; }
